<template>
    <div id="cesiumContainer"></div>
</template>
<script>
import * as Cesium from "cesium/Cesium";
import widget from "cesium/Widgets/widgets.css";
export default {
    name:'spatial_roaming',
    mounted() {
            this.init();
    },
    methods:{
           init() {
                var viewerOption = {
                    geocoder: true, // 地理位置查询定位控件
                    homeButton: true, // 默认相机位置控件
                    timeline: false, // 时间滚动条控件
                    navigationHelpButton: true, // 默认的相机控制提示控件
                    fullscreenButton: false, // 全屏控件
                    scene3DOnly: true, // 每个几何实例仅以3D渲染以节省GPU内存
                    baseLayerPicker: true, // 底图切换控件
                    animation: false, // 控制场景动画的播放速度控件
                    shouldAnimate: true,
                    //关闭星星
                    skyBox: new Cesium.SkyBox({
                        show: true
                      })
                    };
                  
                    let viewer = new Cesium.Viewer(this.$el,viewerOption);
                    viewer._cesiumWidget._creditContainer.style.display = "none";// 隐藏版权
                    viewer.scene.sun.destroy(); //去掉太阳
                    viewer.scene.sun = undefined; //去掉太阳
                    viewer.scene.moon.destroy(); //去掉月亮
                    viewer.scene.moon = undefined; //去掉月亮
                    viewer.clock.shouldAnimate = true;
    
                    var startLatitude = 35;
                    var startLongitude = -120;
                    var endLongitude;
                    var startTime = Cesium.JulianDate.now();
                    // Add a polyline to the scene. Positions are dynamic.
                    var isConstant = false;
                    var redLine =  viewer.entities.add({
                        polyline : {
                            // This callback updates positions each frame.
                            positions : new Cesium.CallbackProperty(function(time, result) {
                                endLongitude = startLongitude + 0.001 * Cesium.JulianDate.secondsDifference(time, startTime);
                                return Cesium.Cartesian3.fromDegreesArray([startLongitude, startLatitude, endLongitude, startLatitude], Cesium.Ellipsoid.WGS84, result);
                            }, isConstant),
                            width : 0,
                        }
                    });
                 
                    var startCartographic = Cesium.Cartographic.fromDegrees(startLongitude, startLatitude);

                    // use scratch object to avoid new allocations per frame.
                    var endCartographic = new Cesium.Cartographic();
                    var scratch = new Cesium.Cartographic();
                    var geodesic = new Cesium.EllipsoidGeodesic();

                    function getMidpoint(time, result) {
                        // Get the end position from the polyLine's callback.
                        var endPoint = redLine.polyline.positions.getValue(time, result)[1];
                        endCartographic = Cesium.Cartographic.fromCartesian(endPoint);

                        geodesic.setEndPoints(startCartographic, endCartographic);
                        var midpointCartographic = geodesic.interpolateUsingFraction(0.04, scratch);
                        return Cesium.Cartesian3.fromRadians(midpointCartographic.longitude, midpointCartographic.latitude);
                    }

                    // Label the polyline with calculated length.
                    var label = viewer.entities.add({
                        position : new Cesium.CallbackProperty(getMidpoint, isConstant),
                        label : {
                            text:'',
                        },
                    });
                    viewer.trackedEntity = label;
                   
            }
    }
}
</script>
<style scoped>
 #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>